/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 18/02/22
 */

import React from 'react';
import AllocationsTile from '@/components/pages/dashboard/tiles/ChartTile/AllocationsTile';
import { useAssignment } from '@/components/contexts/AssignmentContext/useAssignment';

const AssignmentAllocationsTile = () => {
    const { currentAssignment, loading, error } = useAssignment();

    return <AllocationsTile workplanVersion={currentAssignment} loading={loading} error={error} />;
};

export default AssignmentAllocationsTile;
